"use client";

import { apiGetUnreadCount } from "@/api/notify";
import { useAuthStore } from "@/store/auth";
import { useUnreadCount } from "@/store/unread-count";
import { get } from "@/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

export function UnreadCountSync() {
    const { setUnreadCount } = useUnreadCount();
    const isLogin = useAuthStore( ( state ) => state.isLogin );

    useEffect( () => {
        if ( isLogin ) return;
        setUnreadCount( { announcement: 0, system: 0, total: 0 } );
    }, [ isLogin, setUnreadCount ] );

    useQuery( {
        queryKey: [ "unreadCount" ],
        queryFn: async () => {
            const [ isOk, res ] = await apiGetUnreadCount();
            if ( isOk && res?.data ) {
                setUnreadCount( {
                    announcement: get( res, "data.announcement", 0 ),
                    system: get( res, "data.system", 0 ),
                    total: get( res, "data.total", 0 ),
                } );
                return get( res, "data", {} );
            }
            return null;
        },
        staleTime: 0,
        refetchOnMount: "always",
        refetchInterval: 1000 * 60,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: isLogin,
    } );

    return null;
}
